import { create } from 'zustand'
import { formularioSlice } from './slices/formularioSlice'
import { sucursalesSlice } from './slices/sucursalesSlice'
import { escaneoSlice } from './slices/escaneoSlice'

const useEscaneosStore = create((set,get) => ({
    error:null,
    isLoading: true,
    elNavigate:null,
    nombre_cliente:"",
    nombre_usuario:"",
    fecha:"",
    fecha_alta:"",
    id_cli:0,
    datos: {
        id:0,
        consumo:"",
        total_gasto:0,
        total_descuento:0,
        estatus:1,
        id_sucursal:0,
        motivo:""
    },
    sucursalesEscaneo: [],
    cupones: [],
    descuentos:[],	
    promociones:[],
    setNavigate: (navigate) => set({ elNavigate: navigate }),
    actualizarId: (id) => set({ datos: { ...get().datos, id } }),
    handleSave: () => get().insertarEscaneo(),
    handleSucursales: (e) => { 
        set({ sucursalesEscaneo: e })
        set({ datos: { ...get().datos, id_sucursal: e.value } })
    },
    iniciar: async() => {
        await get().obtenerSucursales();
        await get().obtenerEscaneo();
        set({ isLoading: false });
    },
    limpiar: () => {
        set({
            nombre_cliente:"",
            nombre_usuario:"",
            isLoading: true,
            id_cli:0,
            datos: {
                id:0,
                consumo:"",
                total_gasto:"",
                total_descuento:0,
                estatus:1,
                id_sucursal:0,
                motivo:""
            },
            cupones:[],
            elNavigate:null,
            error:null,
        })
    },
    ...formularioSlice(set,get),
    ...escaneoSlice(set,get),
    ...sucursalesSlice(set,get),
}))
  
export default useEscaneosStore